import { __decorate, __metadata, __param } from "tslib";
import qs from 'qs';
import { format } from '@/@core/utils/string';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
import _ from 'lodash';
import { OAuthParamsKeys } from '@/views/company-next/CompanySso/SsoOAuth/oauth.common';
import { SSEStreamServiceImpl } from '@patsnap-utils/sse/src';
import { X_PATSNAP_FROM } from '@/service/AuthService';
function jsonToFromData(data) {
    const formData = new FormData();
    const keys = Object.keys(data);
    keys.forEach(key => {
        formData.append(key, data[key]);
    });
    return formData;
}
let CompanyApi = class CompanyApi {
    constructor(http, urls, passportPublicUrls, boHelper, authService) {
        this.http = http;
        this.urls = urls;
        this.passportPublicUrls = passportPublicUrls;
        this.boHelper = boHelper;
        this.authService = authService;
        this.getCompanyInfo = (company_id, includePrivileges = false) => {
            const url = format(this.urls.getCompanyInfo, {
                company_id,
            });
            return this.http.get({
                url,
                params: {
                    includeDomains: true,
                    includePrivileges,
                },
                uuid: `${url}?includeDomains=true&includePrivileges=${includePrivileges}`,
            });
        };
        this.getQueryCompanies = (params) => {
            return this.http.get({
                url: this.urls.getQueryCompanies,
                params: {
                    iDisplayLength: 20,
                    ...params,
                },
            });
        };
        this.getCompaniesByKeyword = (keyword, params) => {
            const url = this.urls.getCompanyByKeyword;
            const _params = _.assign({ company_name: keyword }, params || {});
            return this.http.get({
                url,
                params: _params,
            });
        };
        /**
         * 创建公司
         */
        this.postCreateCompany = (params) => {
            const url = this.urls.postCreateCompany;
            return this.http.post({
                url,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                data: qs.stringify(params),
            });
        };
        this.getCheckCompanyName = (company_name) => {
            const url = this.urls.getCheckCompanyName;
            return this.http.get({
                url,
                params: {
                    company_name,
                },
            });
        };
        this.getSalesforceCompanyName = (company_name) => {
            const url = this.urls.getSalesforceCompanyName;
            return this.http.get({
                url,
                params: {
                    company_name,
                },
            });
        };
        // 查询公司在某时间段的产品
        this.getQueryCompanyProducts = (params) => {
            const url = this.urls.getQueryCompanyProducts;
            return this.http.get({
                url,
                params,
            });
        };
        /**
         * 安全设置提交数据
         */
        this.patchCompanySetting = (company_id, params) => {
            const url = format(this.urls.patchCompanySetting, {
                company_id,
            });
            return this.http.patch({
                url,
                data: params,
            });
        };
        this.patchCompanyTrialSecuritySettings = (params) => {
            return this.http.patch({
                url: this.urls.patchCompanyTrialSecuritySettings,
                data: params,
            });
        };
        /**
         * 获取安全设置数据
         * @param company_id
         * @returns
         */
        this.getCompanySecurity = (company_id) => {
            const url = format(this.urls.getCompanySecurity, {
                company_id,
            });
            return this.http.get({
                url,
                params: {
                    includeDomains: true,
                },
                uuid: url,
            });
        };
        /**
         * 常规设置
         */
        this.patchCompanyGeneralSetting = (company_id, params) => {
            const url = format(this.urls.patchCompanyGeneralSetting, {
                company_id,
            });
            return this.http.patch({
                url,
                data: params,
            });
        };
        /**
         * sso 设置
         */
        this.patchCompanySsoSetting = (company_id, params) => {
            const url = format(this.urls.patchCompanySsoSetting, {
                company_id,
            });
            const paramsData = {
                allowSamlDisplay: params.allow_saml_display,
                allowCarsiDisplay: params.allow_carsi_display,
                metadataUrl: params.metadata_url,
                thirdLogin: params.third_login,
                publicKey: params.public_key,
                privateKey: params.private_key,
                idpUid: params.idp_uid,
                ipRestrictFromCarsi: params.ip_restrict_from_carsi,
                ipRange: params.ip_range,
                ipv6: params.ipv6,
                agentIdDingtalk: params.agent_id_dingtalk,
                corpIdDingtalk: params.corp_id_dingtalk,
                appSecretDingtalk: params.app_secret_dingtalk,
                appIdDingtalk: params.app_id_dingtalk,
                accessTokenUrlDingtalk: params.access_token_url_dingtalk,
                userIdUrlDingtalk: params.user_id_url_dingtalk,
                userInfoUrlDingtalk: params.user_info_url_dingtalk,
                dingtalkSsoEnabled: params.dingtalk_sso_enabled,
                wechatEnterpriseSsoEnabled: params.wechat_enterprise_sso_enabled,
                agentIdWechatEnterprise: params.agent_id_wechat_enterprise,
                corpIdWechatEnterprise: params.corp_id_wechat_enterprise,
                secretWechatEnterprise: params.secret_wechat_enterprise,
                domain_verify_txt: params.domain_verify_txt,
                feishuSsoEnabled: params.feishu_sso_enabled,
                appIdFeishu: params.app_id_feishu,
                appSecretFeishu: params.app_secret_feishu,
                accessTokenUrlFeishu: params.access_token_url_feishu,
                userInfoUrlFeishu: params.user_info_url_feishu,
                samlRpCertificate: params.saml_rp_certificate,
                samlRpPrivateKey: params.saml_rp_private_key,
                ..._.pick(params, OAuthParamsKeys),
                redirectUrl: params.redirect_url || '',
            };
            const formData = jsonToFromData(paramsData);
            return this.http.patchForm({
                url,
                data: formData,
            });
        };
        /**
         * 获取企业微信定制授权二维码
         */
        this.getCompanyCustomizedAuthUrl = (company_id) => {
            return this.http.get({
                url: this.urls.getCompanyCustomizedAuthUrl,
                params: {
                    company_id,
                },
            });
        };
        /**
         * 获取授权grant配置数据
         */
        this.getCompanyGrant = (company_id) => {
            const url = format(this.urls.getCompanyGrant, {
                company_id,
            });
            return this.http.get({
                url,
            });
        };
        /**
         * 提交设置数据
         */
        this.patchCompanySettingForm = (company_id, params) => {
            const url = format(this.urls.patchCompanySettingForm, {
                company_id,
            });
            const formData = jsonToFromData(params);
            return this.http.patchForm({
                url,
                data: formData,
            });
        };
        // CRM相关
        this.getCompanyCrmInfo = (companyName) => {
            const url = this.urls.getCompanyCrmInfo;
            return this.http.get({
                url,
                params: {
                    companyName,
                },
            });
        };
        this.getCompanyInfoBySalesforceId = (salesforceId) => {
            const url = this.urls.getCompanyInfoBySalesforceId;
            return this.http.get({
                url,
                params: {
                    salesforceId,
                },
            });
        };
        /**
         * 公司批量编辑
         */
        this.postCompaniesBatchEdit = (params) => {
            const url = this.urls.postCompaniesBatchEdit;
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 获取公司 sso配置 用户信息key的映射
         * /company/sso/query/companyId?companyId=6b8fe9385a684b41b3f7300859da7f5c
         */
        this.getCompanySSOQueryCompanyId = (companyId) => {
            const url = this.urls.getCompanySSOQueryCompanyId;
            return this.http.get({
                url,
                params: {
                    companyId,
                },
            });
        };
        this.postCompanySsoKeepAttribute = (params) => {
            const url = this.urls.postCompanySsoKeepAttribute;
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 加密
         */
        this.getPublicKeyApi = () => {
            const url = this.passportPublicUrls.getPublicKey;
            return this.http.get({
                url,
            });
        };
        /** 系统限制 */
        this.getSystemLimit = (company_id) => {
            const url = format(this.urls.getCompanySystemLimit, { company_id });
            return this.http.get({
                url,
                uuid: url,
            });
        };
        this.patchSystemLimit = (company_id, data) => {
            const url = format(this.urls.getCompanySystemLimit, { company_id });
            return this.http.patch({
                url,
                data,
            });
        };
        this.patchJwtLimit = (company_id, data) => {
            const url = format(this.urls.patchCompanyJwtLimit, { company_id });
            return this.http.patch({
                url,
                data,
            });
        };
        this.getSalesCSByCompanyId = (company_id) => {
            const url = this.urls.getSalesCSByCompanyId;
            return this.http.get({
                url,
                params: {
                    companyId: company_id,
                },
            });
        };
        this.getMetaDataChecked = (meta_data_url) => {
            const url = this.urls.getMetaDataChecked;
            return this.http.get({
                url,
                params: { metadata_url: meta_data_url },
            });
        };
        this.postCompanyInvitation = (data) => {
            const url = this.urls.postCompanyInvitation;
            return this.http.post({
                url,
                data,
            });
        };
        this.postCompanySsoOaIp = (company_id, ips) => {
            const url = format(this.urls.postCompanySsoOaIp, { company_id });
            return this.http.post({
                url,
                data: ips,
            });
        };
        this.getCompanySsoOaIp = (company_id) => {
            const url = format(this.urls.getCompanySsoOaIp, { company_id });
            return this.http.get({
                url,
            });
        };
        this.getCompanyPackageAndProduct = (company_id) => {
            const url = format(this.urls.getCompanyPackageAndProduct, { company_id });
            return this.http.get({
                url,
            });
        };
        this.postCompaniesUnbindUserCarsi = (company_id) => {
            const url = format(this.urls.postCompaniesUnbindUserCarsi, { company_id });
            return this.http.post({
                url,
            });
        };
    }
    /** 获取公司列表 */
    getCompanyList(params) {
        const url = this.urls.getCompanyList;
        params = this.boHelper.maybeSerializeDate(params, 's_privilege_end_at_start', 's_privilege_end_at_end', 's_created_at_start', 's_created_at_end');
        window.rvTrack('Search Company List', params);
        const { sales_emails, s_charge_mode, ...otherParams } = params;
        return this.http.post({
            url,
            params: otherParams,
            data: _.pickBy({
                sales_emails,
                charge_modes: _.isEmpty(s_charge_mode) ? [] : _.split(s_charge_mode, ','),
            }, (value) => !_.isEmpty(value)),
        });
    }
    getQrCodeByUrl(urlStr) {
        const url = this.urls.getQrCodeByUrl;
        return this.http.get({
            url,
            params: {
                text: urlStr,
            },
        });
    }
    // 客户360
    getCustomerViewCompanyMainProduct(company_id) {
        const url = this.urls.getCustomerViewCompanyMainProduct;
        return this.http.get({
            url,
            params: {
                company_id,
            },
        });
    }
    getCustomerViewCompanyStat(params) {
        const url = this.urls.getCustomerViewCompanyStat;
        return this.http.get({
            url,
            params,
        });
    }
    getCustomerViewCompanyAttribute(company_id) {
        const url = this.urls.getCustomerViewCompanyAttribute;
        return this.http.get({
            url,
            params: {
                company_id,
            },
        });
    }
    getCustomerViewCompanyLicense(company_id) {
        const url = this.urls.getCustomerViewCompanyLicense;
        return this.http.get({
            url,
            params: {
                company_id,
            },
        });
    }
    postCompanyLoginSettingLoginChannel(params) {
        const url = this.urls.postCompanyLoginSettingLoginChannel;
        return this.http.post({
            url,
            data: params,
        });
    }
    postCompanyLoginSettingCopywriting(params) {
        const url = this.urls.postCompanyLoginSettingCopywriting;
        return this.http.post({
            url,
            data: params,
        });
    }
    getCustomerAiReport(company_id) {
        const url = format(this.urls.getCustomerAiReport, { company_id });
        return this.http.get({
            url,
        });
    }
    postCustomerAiReportFeedback(params) {
        const url = this.urls.postCustomerAiReportFeedback;
        return this.http.post({
            url,
            data: params,
        });
    }
    sseCustomerAiReport(company_id) {
        const url = format(this.urls.sseCustomerAiReport, { company_id });
        return new SSEStreamServiceImpl({
            url,
            headerOptions: {
                asyncToken: this.authService.getPassportToken,
                lang: 'cn',
                from: X_PATSNAP_FROM,
            },
            refreshToken: this.http.request,
        });
    }
    getCompanyTagPagination(params) {
        return this.http.get({
            url: this.urls.getCompanyTagPagination,
            params,
        });
    }
};
CompanyApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CompanyApiUrls)),
    __param(2, inject(Symbols.PassportPublicUrls)),
    __param(3, inject(Symbols.BoHelperService)),
    __param(4, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object])
], CompanyApi);
export { CompanyApi };
